export enum DeferLogicOptions {
  FROM_ENTRANCE = 'FROM_ENTRANCE',
  FROM_EXIT = 'FROM_EXIT',
}
